module.exports = __webpack_public_path__ + "images/FUSA_icons/100-shopping-cart.3baa3279306ff5defe9f2e96d1cfd1c5.svg";